import React from 'react';
import BlogPreviewCard from './BlogPreviewCard';

const BlogPreviewColumns = ({ blogs }) => {
  if (!blogs || blogs.length === 0) return null;

  // Split blogs into 3 columns
  const column1 = blogs.filter((_, index) => index % 3 === 0);
  const column2 = blogs.filter((_, index) => index % 3 === 1);
  const column3 = blogs.filter((_, index) => index % 3 === 2);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
      <div className="space-y-0">
        {column1.map((blog) => (
          <BlogPreviewCard key={blog._id} blog={blog} />
        ))}
      </div>
      <div className="space-y-0">
        {column2.map((blog) => (
          <BlogPreviewCard key={blog._id} blog={blog} />
        ))}
      </div>
      <div className="space-y-0">
        {column3.map((blog) => (
          <BlogPreviewCard key={blog._id} blog={blog} />
        ))}
      </div>
    </div>
  );
};

export default BlogPreviewColumns;
